export default __webpack_public_path__ + "static/media/clickNormal.47f90c48.mp3";